import { PartialStoryFn, StoryContext } from '@storybook/addons';
import { themes } from '@storybook/theming';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { ButtonIcon } from '../button-icon';

const meta = {
  args: {
    disabled: '',
    formId: '',
    href: '',
    icon: 'calendar',
    label: 'Button icon label',
    name: '',
    rel: '',
  },
  argTypes: {
    appearance: { table: { disable: true } },
    disabled: { table: { disable: true } },
    formId: { table: { disable: true } },
    href: { table: { disable: true } },
    icon: { table: { disable: true } },
    label: { table: { disable: true } },
    name: { table: { disable: true } },
    palette: { table: { disable: true } },
    rel: { table: { disable: true } },
    size: { table: { disable: true } },
    target: { table: { disable: true } },
    type: { table: { disable: true } },
  },
  decorators: [
    (story: PartialStoryFn, { args: { palette } }: StoryContext) =>
      html`
        <style type="text/css">
          .sbdocs-preview, .sb-show-main {
            ${palette === 'inverse' ? `background: ${themes.dark?.appBg}` : ''};
          }
        </style>
        ${story()}
      `,
  ],
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Button icon/',
};

interface Story {
  appearance: ButtonIcon['appearance'];
  disabled: ButtonIcon['disabled'];
  formId: ButtonIcon['formId'];
  href: ButtonIcon['href'];
  icon: ButtonIcon['icon'];
  label: ButtonIcon['label'];
  name: ButtonIcon['name'];
  palette: ButtonIcon['palette'];
  rel: ButtonIcon['rel'];
  size: ButtonIcon['size'];
  target: ButtonIcon['target'];
  type: ButtonIcon['type'];
}

const story = ({
  appearance,
  disabled,
  formId,
  href,
  icon,
  label,
  name,
  palette,
  rel,
  size,
  target,
  type,
}: Story) => html`
  <abds-button-icon
    appearance="${ifDefined(appearance || undefined)}"
    disabled="${ifDefined(disabled || undefined)}"
    formId="${ifDefined(formId || undefined)}"
    href="${ifDefined(href || undefined)}"
    icon="${ifDefined(icon || undefined)}"
    label="${ifDefined(label || undefined)}"
    name="${ifDefined(name || undefined)}"
    palette="${ifDefined(palette || undefined)}"
    rel="${ifDefined(rel || undefined)}"
    size="${ifDefined(size || undefined)}"
    target="${ifDefined(target || undefined)}"
    type="${ifDefined(type || undefined)}"
  ></abds-button-icon>
`;

export { meta, story };
